/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetPageParameter,
  CreateStudentRequest,
  CreateUserContactRequest,
  GetStudentResponse,
  GetUserContactResponse,
  GetUserSettingsResponse,
  ProblemDetails,
  Result,
  ResultOfCreateStudentResponse,
  ResultOfCreateUserContactResponse,
  UpdateProfileRequest,
  UpdateProfileSettingsRequest,
  UpdateUserContactRequest,
} from '../models/index';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateStudentRequestFromJSON,
    CreateStudentRequestToJSON,
    CreateUserContactRequestFromJSON,
    CreateUserContactRequestToJSON,
    GetStudentResponseFromJSON,
    GetStudentResponseToJSON,
    GetUserContactResponseFromJSON,
    GetUserContactResponseToJSON,
    GetUserSettingsResponseFromJSON,
    GetUserSettingsResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateStudentResponseFromJSON,
    ResultOfCreateStudentResponseToJSON,
    ResultOfCreateUserContactResponseFromJSON,
    ResultOfCreateUserContactResponseToJSON,
    UpdateProfileRequestFromJSON,
    UpdateProfileRequestToJSON,
    UpdateProfileSettingsRequestFromJSON,
    UpdateProfileSettingsRequestToJSON,
    UpdateUserContactRequestFromJSON,
    UpdateUserContactRequestToJSON,
} from '../models/index';

export interface ApiUserProfileIdContactPostRequest {
    id: number;
    createUserContactRequest: CreateUserContactRequest;
    xTenantID?: number;
}

export interface ApiUserProfileIdContactPutRequest {
    id: number;
    updateUserContactRequest: UpdateUserContactRequest;
    xTenantID?: number;
}

export interface ApiUserProfileIdContactsGetRequest {
    id: number;
    ids?: Array<ApiUserTasksGetPageParameter>;
    xTenantID?: number;
}

export interface ApiUserProfileIdContactsPutRequest {
    id: number;
    updateUserContactRequest: Array<UpdateUserContactRequest>;
    xTenantID?: number;
}

export interface ApiUserProfileIdContactsUserContactIdDeleteRequest {
    id: number;
    userContactId: number;
    xTenantID?: number;
}

export interface ApiUserProfileIdPutRequest {
    id: number;
    updateProfileRequest: UpdateProfileRequest;
    xTenantID?: number;
}

export interface ApiUserProfileIdSettingsGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiUserProfileIdSettingsPutRequest {
    id: number;
    updateProfileSettingsRequest: UpdateProfileSettingsRequest;
    xTenantID?: number;
}

export interface ApiUserProfileIdStudentsGetRequest {
    id: number;
    ids?: Array<ApiUserTasksGetPageParameter>;
    xTenantID?: number;
}

export interface ApiUserProfileIdStudentsRegisterPostRequest {
    id: number;
    createStudentRequest: CreateStudentRequest;
    xTenantID?: number;
}

export interface ApiUserProfileIdStudentsSelfRegisterPostRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class UserProfileApi extends runtime.BaseAPI {

    /**
     * Create user contact
     */
    async apiUserProfileIdContactPostRaw(requestParameters: ApiUserProfileIdContactPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateUserContactResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdContactPost().'
            );
        }

        if (requestParameters['createUserContactRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserContactRequest',
                'Required parameter "createUserContactRequest" was null or undefined when calling apiUserProfileIdContactPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/contact`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserContactRequestToJSON(requestParameters['createUserContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateUserContactResponseFromJSON(jsonValue));
    }

    /**
     * Create user contact
     */
    async apiUserProfileIdContactPost(requestParameters: ApiUserProfileIdContactPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateUserContactResponse> {
        const response = await this.apiUserProfileIdContactPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user contact
     */
    async apiUserProfileIdContactPutRaw(requestParameters: ApiUserProfileIdContactPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdContactPut().'
            );
        }

        if (requestParameters['updateUserContactRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserContactRequest',
                'Required parameter "updateUserContactRequest" was null or undefined when calling apiUserProfileIdContactPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/contact`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserContactRequestToJSON(requestParameters['updateUserContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user contact
     */
    async apiUserProfileIdContactPut(requestParameters: ApiUserProfileIdContactPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserProfileIdContactPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get user contacts
     */
    async apiUserProfileIdContactsGetRaw(requestParameters: ApiUserProfileIdContactsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserContactResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdContactsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/contacts`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserContactResponseFromJSON));
    }

    /**
     * Get user contacts
     */
    async apiUserProfileIdContactsGet(requestParameters: ApiUserProfileIdContactsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserContactResponse>> {
        const response = await this.apiUserProfileIdContactsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update multiple contacts
     */
    async apiUserProfileIdContactsPutRaw(requestParameters: ApiUserProfileIdContactsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdContactsPut().'
            );
        }

        if (requestParameters['updateUserContactRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserContactRequest',
                'Required parameter "updateUserContactRequest" was null or undefined when calling apiUserProfileIdContactsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/contacts`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateUserContactRequest']!.map(UpdateUserContactRequestToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple contacts
     */
    async apiUserProfileIdContactsPut(requestParameters: ApiUserProfileIdContactsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserProfileIdContactsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Delete user contact
     */
    async apiUserProfileIdContactsUserContactIdDeleteRaw(requestParameters: ApiUserProfileIdContactsUserContactIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdContactsUserContactIdDelete().'
            );
        }

        if (requestParameters['userContactId'] == null) {
            throw new runtime.RequiredError(
                'userContactId',
                'Required parameter "userContactId" was null or undefined when calling apiUserProfileIdContactsUserContactIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/contacts/{userContactId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"userContactId"}}`, encodeURIComponent(String(requestParameters['userContactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user contact
     */
    async apiUserProfileIdContactsUserContactIdDelete(requestParameters: ApiUserProfileIdContactsUserContactIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserProfileIdContactsUserContactIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update profile
     */
    async apiUserProfileIdPutRaw(requestParameters: ApiUserProfileIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdPut().'
            );
        }

        if (requestParameters['updateProfileRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileRequest',
                'Required parameter "updateProfileRequest" was null or undefined when calling apiUserProfileIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileRequestToJSON(requestParameters['updateProfileRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update profile
     */
    async apiUserProfileIdPut(requestParameters: ApiUserProfileIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserProfileIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get user settings
     */
    async apiUserProfileIdSettingsGetRaw(requestParameters: ApiUserProfileIdSettingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserSettingsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdSettingsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/settings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Get user settings
     */
    async apiUserProfileIdSettingsGet(requestParameters: ApiUserProfileIdSettingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserSettingsResponse> {
        const response = await this.apiUserProfileIdSettingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update profile settings
     */
    async apiUserProfileIdSettingsPutRaw(requestParameters: ApiUserProfileIdSettingsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdSettingsPut().'
            );
        }

        if (requestParameters['updateProfileSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileSettingsRequest',
                'Required parameter "updateProfileSettingsRequest" was null or undefined when calling apiUserProfileIdSettingsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/settings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileSettingsRequestToJSON(requestParameters['updateProfileSettingsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update profile settings
     */
    async apiUserProfileIdSettingsPut(requestParameters: ApiUserProfileIdSettingsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserProfileIdSettingsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get user students
     */
    async apiUserProfileIdStudentsGetRaw(requestParameters: ApiUserProfileIdStudentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetStudentResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdStudentsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/students`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentResponseFromJSON));
    }

    /**
     * Get user students
     */
    async apiUserProfileIdStudentsGet(requestParameters: ApiUserProfileIdStudentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetStudentResponse>> {
        const response = await this.apiUserProfileIdStudentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new student profile in the system
     * Register new student
     */
    async apiUserProfileIdStudentsRegisterPostRaw(requestParameters: ApiUserProfileIdStudentsRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateStudentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdStudentsRegisterPost().'
            );
        }

        if (requestParameters['createStudentRequest'] == null) {
            throw new runtime.RequiredError(
                'createStudentRequest',
                'Required parameter "createStudentRequest" was null or undefined when calling apiUserProfileIdStudentsRegisterPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/students/register`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateStudentRequestToJSON(requestParameters['createStudentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateStudentResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new student profile in the system
     * Register new student
     */
    async apiUserProfileIdStudentsRegisterPost(requestParameters: ApiUserProfileIdStudentsRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateStudentResponse> {
        const response = await this.apiUserProfileIdStudentsRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register yourself as a student to access class enrollment options
     * Self-registration
     */
    async apiUserProfileIdStudentsSelfRegisterPostRaw(requestParameters: ApiUserProfileIdStudentsSelfRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateStudentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserProfileIdStudentsSelfRegisterPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-profile/{id}/students/self-register`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateStudentResponseFromJSON(jsonValue));
    }

    /**
     * Register yourself as a student to access class enrollment options
     * Self-registration
     */
    async apiUserProfileIdStudentsSelfRegisterPost(requestParameters: ApiUserProfileIdStudentsSelfRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateStudentResponse> {
        const response = await this.apiUserProfileIdStudentsSelfRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
